/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SearchLoupeMinusIcon16Light } from './SearchLoupeMinusIcon16Light';
import { SearchLoupeMinusIcon16Regular } from './SearchLoupeMinusIcon16Regular';
import { SearchLoupeMinusIcon16Solid } from './SearchLoupeMinusIcon16Solid';
import { SearchLoupeMinusIcon20Light } from './SearchLoupeMinusIcon20Light';
import { SearchLoupeMinusIcon20Regular } from './SearchLoupeMinusIcon20Regular';
import { SearchLoupeMinusIcon20Solid } from './SearchLoupeMinusIcon20Solid';
import { SearchLoupeMinusIcon24Regular } from './SearchLoupeMinusIcon24Regular';
import { SearchLoupeMinusIcon24Solid } from './SearchLoupeMinusIcon24Solid';
import { SearchLoupeMinusIcon32Regular } from './SearchLoupeMinusIcon32Regular';
import { SearchLoupeMinusIcon64Regular } from './SearchLoupeMinusIcon64Regular';
var sizes = {
    16: {
        light: SearchLoupeMinusIcon16Light,
        regular: SearchLoupeMinusIcon16Regular,
        solid: SearchLoupeMinusIcon16Solid,
    },
    20: {
        light: SearchLoupeMinusIcon20Light,
        regular: SearchLoupeMinusIcon20Regular,
        solid: SearchLoupeMinusIcon20Solid,
    },
    24: {
        regular: SearchLoupeMinusIcon24Regular,
        solid: SearchLoupeMinusIcon24Solid,
    },
    32: {
        regular: SearchLoupeMinusIcon32Regular,
    },
    64: {
        regular: SearchLoupeMinusIcon64Regular,
    },
};
export var SearchLoupeMinusIcon = forwardRef('SearchLoupeMinusIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
